/****************************************************
 * Module Name:  labStoneReceived.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { DataGridPro, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip, Typography, Stack } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import LabProxy from "../../utility/proxy/manager/labProxy";
import { useEffect } from "react";
import Select from "react-select";
import CircularProgress from "@mui/material/CircularProgress";
import LabTestProxy from "../../utility/proxy/manager/labTestProxy";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import MarkStoneReceivedModal from "./markStoneReceivedModal";
import Constants from "../../utility/constants";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import StoneDetailModal from "../common/stoneDetailModal";
import { LoadingButton } from "@mui/lab";
import CommonStoneSelection from "../common/commonStoneSelection";
import PageTitle from "../common/pageTitle";

const LabStoneReceived = () => {
  const [lab, setLab] = useState([]);
  const [labOption, setLabOption] = useState([]);

  const [listData, setListData] = useState([]);

  const [stoneReceivedListLoader, setStoneReceivedLoader] = useState(false);

  const [selectionModel, setSelectionModel] = useState([]);
  const [fetchData, setFetchData] = useState(false);

  const [show, setShow] = useState(false);
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [rejectedStones, setRejectedStones] = useState([]);
  const [errorSnackbar, setErrorSnackbar] = useState(false);

  const [stoneId, setStoneId] = useState("");
  const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
  const [columnNames, setColumnNames] = React.useState([]);
  // eslint-disable-next-line
  const [local_Permission, setLocal_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.OPERATION_LAB_STONERECEIVED
    )
  );

  //top most summary table 
  const [noOfSelectedStones, setNoOfSelectedStones] = useState("0");
  const [selectedTotalSize, setSelectedTotalSize] = useState("0");
  const [selectedAvgDiscount, setSelectedAvgDiscount] = useState("0");
  const [selectedavgPrice, setSelectedavgPrice] = useState("0");
  const [selectedtotalPrice, setSelectedtotalPrice] = useState("0");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    PageTitle("OPERATION_LAB_STONERECEIVED");
    getAllLabData();
  }, []);

  const getAllLabData = () => {
    LabProxy.GetAllLab((response) => {
      setAllLabData(response);
    });
  };

  const setAllLabData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = {
        value: data.id,
        label: data.name + " | " + data.location + " | " + data.country,
      };
      optionsArray.push(option);
      return true;
    });
    setLabOption(optionsArray);
    setLab(lab.length === 0 && optionsArray.length > 0 ? optionsArray[0] : lab);

    setFetchData(true);
  };

  useEffect(() => {
    if (fetchData) {
      if (lab.value) {
        handleSearch(lab);
      }
    }
  }, [fetchData, lab]);

  const loadTotalData = (data) => {
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size

    data.forEach((iData) => {
      let pricePerCarat = iData.price
      totalSize += iData.size;
      totalPrice += (iData.size * pricePerCarat);
      total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));

    });
    setNoOfSelectedStones(data.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
  };

  useEffect(() => {
    if (selectionModel.length <= 0) {
      loadTotalData(listData);
      return;
    }
    let totalSize = 0;
    let totalPrice = 0;   //ppc*size
    let total = 0;       //rapnetprice*size
    listData.forEach((iData) => {
      if (selectionModel.includes(iData.stoneid)) {
        let pricePerCarat = iData.price
        totalSize += iData.size;
        totalPrice += (iData.size * pricePerCarat);
        total += (iData.size * ((100 * pricePerCarat) / (100 + iData.discount)));
      }
    });
    setNoOfSelectedStones(selectionModel.length);
    setSelectedTotalSize(Utility.ConvertNumberWithSpecifiedDigits(totalSize));
    setSelectedtotalPrice(Utility.ConvertNumberWithSpecifiedDigits(totalPrice));
    setSelectedavgPrice(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          totalPrice / totalSize
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );
    setSelectedAvgDiscount(
      totalPrice > 0
        ? Utility.ConvertNumberWithSpecifiedDigits(
          (100 - (totalPrice / total) * 100) * -1
        )
        : Utility.ConvertNumberWithSpecifiedDigits(0)
    );

  }, [selectionModel]);

  const handleSearch = (llab) => {
    let statuss = "REPORT_RECEIVED";
    setStoneReceivedLoader(true);
    LabTestProxy.GetAllTestingStonesInALabDetail(
      llab.value,
      statuss,
      (response) => {
        if (response) {
          const distinctStatus = Utility.getDistinctOptions(response, 'status');
          prepareColumns(distinctStatus);
          setListData(response);
          loadTotalData(response);
          setStoneReceivedLoader(false);
          setFetchData(false);
        } else {
          setErrorSnackbar(true);
          setStoneReceivedLoader(false);
        }
      }
    );
  };

  const handleOpen = () => {
    setShow(!show);
    setShowSuccessSnackbar(false);
  };

  const handleValidation = (data) => {
    //TODO do validation if needed here
    return true;
  };

  const handleSelection = (data) => {
    const [tempStockData, tempSelectionModel] = Utility.handleSelection(data, listData, selectionModel);

    setListData(tempStockData);
    setSelectionModel(tempSelectionModel);
  }

  const markStoneReceived = (data) => {
    setLoading(true);
    let labId = lab.value;
    LabTestProxy.MarkStoneReceived(labId, data, (responseData) => {
      if (responseData) {
        setShow(false);
        setRejectedStones(responseData.rejectedstones);
        handleSearch(lab);
        setShowSuccessSnackbar(true);
        setLoading(false);
      } else {
        setErrorSnackbar(true);
        setLoading(false);
      }
    });
  };

  const prepareColumns = (distinctStatus) => {
    let columnNames = [];

    Constants.USER_COLUMN_PERMISSION.forEach(iColPermission => {
      if (columnsData.hasOwnProperty(iColPermission)) {
        const columnData = columnsData[iColPermission];
        if (columnData.field === "status") {
          columnData.type = "singleSelect";
          columnData.valueOptions = distinctStatus;
          columnData.filterOperators = Utility.combinedFilters();
        }
        columnNames.push(columnData);
        if (columnData.field === "stoneid") {
          columnNames.push({
            field: "suratid",
            headerName: "SURATID",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: renderCellExpand,
          })
        }
      }
    });
    setColumnNames(columnNames);
  }

  const columnsData = {
    "item-1": {
      field: "id",
      headerName: "BATCH ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
    },
    "item-2": {
      field: "username",
      headerName: "CREATED BY",
      headerAlign: "center",
      align: "center",
      width: 170,
      renderCell: renderCellExpand,
    },
    "item-3": {
      field: "first_name",
      headerName: "CREATED BY",
      headerAlign: "center",
      align: "center",
      width: 170,
      renderCell: renderCellExpand,
    },
    "62c37a29-d2ff-4c72-8cb3-07e52a83d484": {
      field: "status",
      headerName: "TEST STATUS",
      headerAlign: "center",
      align: "center",
      width: 110,
      renderCell: renderCellExpand,
    },
    "5dd43313-18b9-41a5-9e07-09d61ad6863c": {
      field: "stoneid",
      headerName: "STONEID",
      width: 80,
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
        <Button
          sx={{ textDecorationLine: "underline", color: "black" }}
          onClick={() => handleStoneDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    "9f0b7352-8ca1-459d-944c-eb46dad5aed1": {
      field: "size",
      headerName: "SIZE",
      headerAlign: "center",
      align: "right",
      width: 40,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.size)
    },
    "52599510-9698-4cd3-90b7-7ac22b6af7e2": {
      field: "stonetype",
      headerName: "STONETYPE",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
    },
    "eb5db767-47d2-4444-9b52-7dc35c853fc7": {
      field: "shape",
      headerName: "SHAPE",
      headerAlign: "center",
      align: "center",
      width: 80,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "fe7c00f1-774a-45a2-aec0-e5fb2ea1101e": {
      field: "color",
      headerName: "COLOR",
      headerAlign: "center",
      align: "center",
      width: 65,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "1035d1d0-bc7c-404f-8f58-c80bea2de613": {
      field: "clarity",
      headerName: "CLARITY",
      headerAlign: "center",
      align: "center",
      width: 75,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "798a8663-0f0c-41be-8512-16dd60d5f25e": {
      field: "discount",
      headerName: "DIS",
      headerAlign: "center",
      align: "center",
      width: 50,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.discount)
    },
    "39c634f1-2644-4307-acbb-983b4de4229e": {
      field: "price",
      headerName: "PPC",
      headerAlign: "center",
      align: "right",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
    "7df28e0e-0303-4ff8-a432-9dedb384afa8": {
      field: "total",
      headerName: "TOTAL",
      headerAlign: "center",
      align: "right",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.total)
    },
    "3597803f-8932-40c6-8de6-81006f4d6d5b": {
      field: "cut",
      headerName: "CUT",
      headerAlign: "center",
      align: "center",
      width: 50,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "859c71c9-c9c8-4f2c-9eb7-08e388e505ad": {
      field: "pol",
      headerName: "POL",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      width: 40,
      renderCell: renderCellExpand,
    },
    "5541c182-21b8-496e-b342-b0b89f3d302f": {
      field: "sym",
      headerName: "SYM",
      headerAlign: "center",
      align: "center",
      width: 40,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "8296e627-0be5-4a66-830f-ea6867cea137": {
      field: "flo",
      headerName: "FLO",
      headerAlign: "center",
      align: "center",
      width: 60,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "567202e6-c31c-4c19-9998-1cacae05af6e": {
      field: "depth",
      headerName: "DEPTH",
      headerAlign: "center",
      align: "center",
      width: 70,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "eed9b7eb-17e4-4ec6-9c9d-c299f885544c": {
      field: "width",
      headerName: "WIDTH",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "e5c1f34e-6e1c-4ee8-bb8e-3236716fd1ff": {
      field: "depthpercent",
      headerName: "DEPTH%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "70498a64-1f5f-4f03-8910-a6d7851e4aba": {
      field: "tablepercent",
      headerName: "TABLE%",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 75,
      renderCell: renderCellExpand,
    },
    "d4992de9-92ab-4f9e-ba12-6c746e935611": {
      field: "colordescriptions",
      headerName: "COL DESCRIP",
      headerAlign: "center",
      align: "center",
      width: 110,
      renderCell: renderCellExpand,
    },
    "01e90aca-bdcb-4e8e-80ec-2d7007df8cd3": {
      field: "createdat",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      width: 170,
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    "daffdd4f-4726-4abc-b8b0-fd4750c874be": {
      field: "lab",
      headerName: "LAB",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "19ce7030-402c-495c-84ac-a29093bdb0ac": {
      field: "locationid",
      headerName: "LOCATION ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
    },
    "ab3e506e-bddb-456d-b967-922dcee74d56": {
      field: "location",
      headerName: "LOCATION",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    "f97a0118-3891-4f77-abf7-8636c26d594c": {
      field: "country",
      headerName: "COUNTRY",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "cb7e6add-67ba-4194-ac49-fd0d967db4e8": {
      field: "quality",
      headerName: "QUALITY",
      headerAlign: "center",
      align: "center",
      width: 80,
      renderCell: renderCellExpand,
    },
    "b718f242-4a82-42e7-b98a-40bbf0f67c21": {
      field: "shade",
      headerName: "SHADE",
      headerAlign: "center",
      align: "center",
      width: 60,
      renderCell: renderCellExpand,
    },
    "706a5cfb-e196-43d1-bbe3-c52aad9a46c1": {
      field: "comment",
      headerName: "COMMENT",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "3c62ef48-9538-4df7-9484-a9ae1ba31086": {
      field: "height",
      headerName: "HEIGHT",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      renderCell: renderCellExpand,
    },
    "8eaa8a03-d163-436d-8912-51ea06306f44": {
      field: "certificateid",
      headerName: "CERT",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    "e7210f4a-6e0a-4591-8428-e6845004ed04": {
      field: "crownheight",
      headerName: "CR.HEIGHT",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "c4e65984-1682-4c1e-812b-8938e9078b2d": {
      field: "crownangle",
      headerName: "CR.ANG",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "e3f77521-2c57-46bc-a02b-3c884685d2be": {
      field: "culetsize",
      headerName: "CULET SZ",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 120,
      renderCell: renderCellExpand,
    },
    "e83c2978-9088-49f0-9dc1-bcced73025fd": {
      field: "gridlemin",
      headerName: "GIRDLEMIN",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "cee57bac-9c19-40d5-b51a-51ed913dbf73": {
      field: "intensitylongtitle",
      headerName: "INTENSITYLONGTITLE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "06d2a589-0d42-4dde-8724-acf2448c839a": {
      field: "laserinscription",
      headerName: "INS",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "13d48508-b8c9-4661-8a6c-9fb22a3408a3": {
      field: "measurements",
      headerName: "MEASUREMENTS",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
    },
    "dd934505-1865-48cb-878f-f5d3c18af2d5": {
      field: "note",
      headerName: "NOTE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "61f8a5f2-8516-419a-b6fd-39ef109cc2f4": {
      field: "paviliondepth",
      headerName: "PV.DEPTH",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "db078198-4416-4d53-b3d0-70d3a5418f65": {
      field: "open",
      headerName: "OPEN",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "e9028170-e978-4978-a2c9-1889c1821495": {
      field: "gridlecondition",
      headerName: "GIRDLE COND",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },
    "fe8f55f3-358a-4418-bcdf-c3da4b01db67": {
      field: "gridlepercent",
      headerName: "GIRDLE%",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "daf69bba-bb1f-4d54-9dc7-9383ad429585": {
      field: "pavilionangle",
      headerName: "PV.ANGLE",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    "ecfdfc0c-6a25-4a6d-9c8f-3406c23410af": {
      field: "white",
      headerName: "WHITE",
      headerAlign: "center",
      align: "center",
      width: 120,
      renderCell: renderCellExpand,
    },

  };

  const handleStoneDetailModal = (params) => {
    setStoneId(params.value);
    setShowStoneDetailModal(true);
  };

  const handleClose = () => {
    setShowSuccessSnackbar(false);
    setShowStoneDetailModal(false);
  };

  const columns = columnNames;

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          alignItems: "center",
          marginHorizontal: "5px",
          "&.MuiDataGrid-toolbarContainer": {
            padding: "0px 4px !important",
          },
        }}
      >
        <CommonStoneSelection
          title={"Enter multiple Stone Ids"}
          handleSelection={handleSelection}
          buttonDisabled={listData.length === 0}
        />

        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport />
        <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />

        {stoneReceivedListLoader ? (
          <CircularProgress size="1rem" />
        ) : (
          <Tooltip title="Reload List">
            <RefreshOutlinedIcon
              onClick={() => handleSearch(lab)}
              color="primary"
              fontSize="medium"
              sx={{ cursor: "pointer" }}
            />
          </Tooltip>
        )}

        {Utility.isUpdateAllowed(local_Permission) ? (
          <Tooltip title="Mark as STONE_RECEIVED">
            <Button
              variant="outlined"
              component="label"
              size="small"
              sx={{ ml: "5px" }}
              startIcon={<AssignmentTurnedInIcon size="large" />}
              disabled={selectionModel.length < 1}
              onClick={handleOpen}
              loading={loading}
            >
              Mark Stone Received
            </Button>
          </Tooltip>
        ) : null}
        <GridToolbarQuickFilter debounceMs={500} />
      </GridToolbarContainer>
    )
  }
  return (
    <div>
      <TabMenuSnackbar
        show={errorSnackbar}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Error"}
        handleClose={() => setErrorSnackbar(false)}
      />
      {showStoneDetailModal ? (
        <StoneDetailModal
          show={showStoneDetailModal}
          stoneId={stoneId}
          handleClose={handleClose}
        />
      ) : null}
      {handleValidation ? (
        <TabMenuSnackbar
          show={showSuccessSnackbar}
          message={
            rejectedStones.length > 0
              ? `Unfortunately these Stones could not be marked :- ${rejectedStones.join(
                ", "
              )}`
              : `Stones marked Successfully`
          }
          variant={rejectedStones.length > 0 ? "error" : "success"}
          autoHide={rejectedStones.length > 0 ? false : true}
          title={rejectedStones.length > 0 ? "Error" : "Success"}
          handleClose={handleClose}
        />
      ) : null}
      {show && (
        <MarkStoneReceivedModal
          show={show}
          setShow={setShow}
          handleValidation={handleValidation}
          handleSave={markStoneReceived}
          stoneId={selectionModel}
          sourceData={listData}
          loading={loading}
        />
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          width: "100%",
          mb: 3,
          mt: 2,
          gap: 2,
          flexWrap: "wrap",
          alignItems: { md: "center" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 1,
            alignItems: { sm: "center" },
            flex: { xs: "1 1 100%", md: "0 1 25%" },
          }}
        >
          <Typography sx={{ minWidth: 50 }}>Lab</Typography>
          <Box sx={{ flex: 1 }}>
            <Select
              menuPlacement="auto"
              blurInputOnSelect={false}
              menuPortalTarget={document.body}
              styles={Constants.Styles}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={labOption}
              value={lab}
              onChange={(e) => setLab(e)}
            />
          </Box>
        </Box>

        <Box
          sx={{
            mt: { xs: 1, md: 0 },
            flexShrink: 0,
          }}
        >
          <LoadingButton
            loading={stoneReceivedListLoader}
            disabled={labOption.length === 0}
            loadingPosition="start"
            variant="contained"
            onClick={() => handleSearch(lab)}
            startIcon={<SearchOutlinedIcon />}
          >
            Search
          </LoadingButton>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mt: { xs: 3, sm: "20px" },
            mb: { xs: 3, sm: "12px" },
            width: { xs: "100%", sm: "auto" },
            overflow: "hidden",
            color: "black",
            fontWeight: "normal",
            px: 1,
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            useFlexGap
            flexWrap="wrap"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              justifyContent: "flex-start",
            }}
          >
            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
              No of Stones: <b>{noOfSelectedStones}</b>
            </Typography>
            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
              Total Weight: <b>{selectedTotalSize}</b>
            </Typography>
            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
              Total Price: <b>{selectedtotalPrice}</b>
            </Typography>
            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
              Avg Price: <b>{selectedavgPrice}</b>
            </Typography>
            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
              Avg Discount: <b>{selectedAvgDiscount}</b>
            </Typography>
          </Stack>
        </Box>
      </Box>


      <Box
        sx={{
          backgroundColor: '#fff',
          color: '#000',
          width: "100%",
          position: "relative",
          "& .MuiTablePagination-selectLabel": {
            marginTop: "15px",
          },
          "& .MuiTablePagination-displayedRows": {
            marginTop: "15px",
          },
          "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
            fontWeight: Constants.defaultFontWeight,
          },
          "& .css-cc8tf1": {
            fontWeight: Constants.defaultFontWeight,
          },
          height: "67vh",
        }}
      >
        <DataGridPro
          disableRowSelectionOnClick={true}
          // getRowHeight={() => "auto"}
          sx={{
            '& .MuiDataGrid-columnHeader': {
              color: '#fff',
              backgroundColor: 'grey',
            },
            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
              py: "4px",
            },
            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
              py: "12px",
            },
            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
              py: "18px",
            },

            fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
          }}
          density="compact"
          loading={stoneReceivedListLoader}
          slots={{ toolbar: CustomToolbar }}
          rows={listData}
          columns={columns}
          getRowId={(row) => row.stoneid}
          checkboxSelection={true}
          onRowSelectionModelChange={(newSelectionModel) => {
            setSelectionModel(newSelectionModel);
          }}
          rowSelectionModel={selectionModel}
          initialState={{
            columns: {
              columnVisibilityModel: {
                // Hide columns id, the other columns will remain visible
                labname: false,
                country: false,
                first_name: false,
                username: false,
                remark: false,
                report: false,
                resultdate: false,
                cutpolsym: false,
                lab: false,
                locationid: false,
                quality: false,
                certificateid: false,
                culetsize: false,
                culetcondition: false,
                gridlemin: false,
                intensitylongtitle: false,
                note: false,
                paviliondepth: false,
                open: false,
                gridlecondition: false,
                gridlepercent: false,
                pavilionangle: false,
                white: false,
                laserinscription: false,
                shade: false,
                height: false,
                crownangle: false,
                crownheight: false,
                repacode: false,
                suratid: false
              },
            },
            sorting: {
              sortModel: [{ field: "stoneid", sort: "asc" }],
            },
            pagination: {
              paginationModel: Constants.pageSize,
            },
          }}
          pageSizeOptions={Constants.pageSizeOptions}
          pagination
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
        />
      </Box>
    </div>
  );
};

export default LabStoneReceived;
